// extracted by mini-css-extract-plugin
export default {"container":"map_container__Sz08a","map":"map_map__mfNLq"};